// removed by extract-text-webpack-plugin
module.exports = {"fullscreen":"src-components-fullscreen----styles-module---fullscreen---1zd9L","first":"src-components-fullscreen----styles-module---first---1NMJC src-components-fullscreen----styles-module---fullscreen---1zd9L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/fullscreen/styles.module.css
// module id = 99
// module chunks = 79611799117203 213534597649335